<template>
  <nav class="vehicle-page navbar">
    <div class="icons">
      <a
        class="icons_img"
        title="起亚汽车官网"
        href="/"
        code-ga="event, C02_everypage, 全站导航点击, C02A06L05_everypage_全站导航点击_起亚logo"
      >
        <i class="icon icon-logo-kn"></i>
      </a>
    </div>
    <div class="navbar-group">
      <ul class="item">
        <li class="important">
          <a
            href="/vehicles/"
            code-ga="event, C02_everypage, 全站导航点击, C02A06L05_everypage_全站导航点击_全系车型"
            >全系车型 <i></i
          ></a>
        </li>
        <li class="important">
          <a
            href="/shop-made-easy/"
            code-ga="event, C02_everypage, 全站导航点击, C02A06L06_everypage_全站导航点击_购车指南"
            >购车指南 <i></i
          ></a>
        </li>
        <li>
          <a
            href="/promotions/"
            code-ga="event, C02_everypage, 全站导航点击, C02A06L07_everypage_全站导航点击_市场活动"
            >市场活动 <i></i
          ></a>
        </li>

        <li>
          <a
            href="/owners/"
            code-ga="event, C02_everypage, 全站导航点击, C02A06L08_everypage_全站导航点击_车主服务"
            >车主服务 <i></i
          ></a>
        </li>
        <li>
          <a
            href="/test-drive/"
            code-ga="event, C02_everypage, 全站导航点击, C02A06L09_everypage_全站导航点击_预约试驾"
            >预约试驾 <i></i
          ></a>
        </li>
        <li>
          <a
            href="/dealer/"
            code-ga="event, C02_everypage, 全站导航点击, C02A06L10_everypage_全站导航点击_经销商查询"
            >经销商查询 <i></i
          ></a>
        </li>
        <li class="search">
          <form>
            <input type="text" placeholder="搜索" style="display:none"/>
            <button type="submit" class="search-submit">
              <i class="icon icon-search"></i>
            </button>
          </form>
        </li>
      </ul>
    </div>
    <div class="phone-btn">
      <div class="menu"></div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "NavBar",
};
</script>

